import { render, staticRenderFns } from "./FormOrganisationCertificates.vue?vue&type=template&id=2fe58946&scoped=true&"
import script from "./FormOrganisationCertificates.vue?vue&type=script&lang=js&"
export * from "./FormOrganisationCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe58946",
  null
  
)

export default component.exports